import { ContextMenuItemView, EventContextMenuClickParams } from '@mark43/cad-api';
import { v4 } from 'uuid';
import { useIntegratedActionBroadcaster } from '../action-broadcaster/use-integrated-action-broadcaster';
import { ContextMenuItem } from '../context-menus/components/context-menu-item';
import { useOpenEventPanel } from '../event-panel/use-open-event-panel';

export function TowVehicleItem({
    contextMenuItemView,
    clickParams,
}: {
    contextMenuItemView: ContextMenuItemView;
    clickParams: EventContextMenuClickParams;
}): React.ReactElement {
    const { trigger } = useIntegratedActionBroadcaster();
    const openEventPanel = useOpenEventPanel();

    const handleSelect = (): void => {
        openEventPanel({
            eventId: clickParams.eventId,
        });
        trigger([
            {
                targetWindowType: 'EVENT_V2',
                id: v4(),
                type: 'ADD_TOW_VEHICLE_TO_EVENT_FORM',
                payload: { eventId: clickParams.eventId },
            },
            {
                targetWindowType: 'EVENT_V2',
                id: v4(),
                type: 'SET_EVENT_PANEL_TAB',
                payload: { eventId: clickParams.eventId, tab: 'VEHICLES' },
            },
        ]);
    };

    return (
        <ContextMenuItem
            dataTrackId="menu-item-tow-vehicle"
            contextMenuItemView={contextMenuItemView}
            onSelect={handleSelect}
        />
    );
}
